import { Loader } from "@progress/kendo-react-indicators";
import { ExpansionPanel, ExpansionPanelContent } from "@progress/kendo-react-layout";
import { Tooltip } from "@progress/kendo-react-tooltip";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Objectives } from "../../../../dataModel/clientModels";
import ListTreatmentIntervention from "./list-intervention";



export interface TreatmentProps{
    objectiveData:Objectives[], 
    
    // goalId, 
    // setIsGoalRefreshed, 
    // isGoalRefreshed, showInactivePlans, isAIGenerated, goal
}

const ListTreatmentObjective = (props:TreatmentProps) => {
    const [treatmentObjective, setTreatmentObjective] = useState([]);
    const [loading, setLoading] = useState(false);
    const [expandedObjective, setExpandedObjective] = React.useState<any>([]);
    const [isDeleteObjectives, setIsDeleteObjectives] = useState(false);
    const [selectedObjective, setSelectedObjective] = useState();
    const [isEditObjectives, setIsEditObjectives] = useState(false);
    const [isAddIntervention, setisAddIntervention] = useState(false);
    const [selectedIntervention, setSelectedIntervention] = useState<any>();

   let counterObj = 1


    const onActionObjective = React.useCallback(
        (event:any, obj:any) => {
            setExpandedObjective({ ...expandedObjective, [obj.id]: !expandedObjective[obj.id] });
            // if (event.expanded === false) {
            //     // setSelectedObjective(obj)
            // }
        },
        [expandedObjective]
    );

    const handleCloseDeleteDialouge = () => {
        setIsDeleteObjectives(false)
    }

    const deletePlans = (obj:any) => {
        setSelectedObjective(obj)
        setIsDeleteObjectives(true)
    }

    const handleCloseEditTreatment = () => {
        setIsEditObjectives(false)
    }

    const handleEditObjectives = (obj:any) => {
        setIsEditObjectives(true)
        setSelectedObjective(obj)
    }

    const handleEditIntervention = (obj:any) => {
        setisAddIntervention(true)
        setSelectedIntervention({ objectiveId: obj.id })
    }

    const handleCloseEditIntervention = () => {
        setisAddIntervention(false)

    }

    if (loading) return <Loader />;

    return (
        <div className="bg_child_light">
            {/* <h4 className='address-title text-grey '><span className='f-20'>Objectives</span></h4> */}
            {props.objectiveData.length > 0 && props.objectiveData.map(ObjectiveItem =>
                <ExpansionPanel
                    id={ObjectiveItem.id + "rand"}
                    title={"Objective #" + counterObj++ + ": " + ObjectiveItem.objective}
                    tabIndex={0}
                    key={ObjectiveItem.id}
                    // expandIcon="k-i-plus  fa fa-plus"
                    // collapseIcon="k-i-minus  fa fa-minus"
                    className="main-objective"
                    expanded={expandedObjective[ObjectiveItem.id]}
                    onAction={(event) => onActionObjective(event, ObjectiveItem)}>
                    {expandedObjective[ObjectiveItem.id] && (
                        <ExpansionPanelContent>

                          

                            
                            <div className="show-upper-event d-flex justify-content-between  py-2 align-items-center"></div>
                            <div className="date-timeshow px-3">

                                <p className="mb-1"><span className="k-icon k-i-calendar-date orange-text-theme "></span><b>Start Date: </b> {ObjectiveItem.startDate === null ? " -/-/-" : moment(ObjectiveItem.startDate).format("M/D/YYYY")}</p>
                                <p className="mb-1"> <span className="k-icon k-i-calendar-date orange-text-theme "></span> <b>End Date: </b> {ObjectiveItem.endDate === null ? " -/-/-" : moment(ObjectiveItem.endDate).format("M/D/YYYY")}</p>
                                <p className="mb-1"> <span className="k-icon k-i-calendar-date orange-text-theme "></span> <b>Target Date: </b> {ObjectiveItem.targetDate === null ? " -/-/-" : moment(ObjectiveItem.targetDate).format("M/D/YYYY")}</p>


                                {/* <p className="mb-1"> <b>Status: </b> {ObjectiveItem.status}</p> */}

                            </div>
                            <h4 className='py-4 mb-0 f-20 address-title'><b>Interventions</b></h4>
                            {ObjectiveItem?.interventions && <ListTreatmentIntervention interventionData={ObjectiveItem?.interventions}  />}
                        </ExpansionPanelContent>
                    )}

                </ExpansionPanel>)
            }
        </div>
    )
}

export default ListTreatmentObjective;